import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="admission-print"
export default class extends Controller {
  connect() {
    document.body.id = "print";
  }

  disconnect() {
    document.body.removeAttribute("id");
  }
}
